import type MeetingTypeExtensionResponse from '../services/schema/MeetingTypeExtensionResponse';

export default function hasSharedLink(
    meetingTypeExtension: MeetingTypeExtensionResponse | undefined | null,
    excludeFromSelfService: boolean | undefined
): boolean {
    // If no meeting type extension, then no share link has been generated
    if (!meetingTypeExtension) {
        return false;
    }

    // When a meeting type is shared, a booking url code is generated saved to meetingTypeExtension.
    // If bookingUrlCode is empty, then the private meeting type is not accessible.
    const hasBookingUrlCode =
        meetingTypeExtension?.bookingUrlCodes &&
        Object.keys(meetingTypeExtension?.bookingUrlCodes).length > 0;

    // If meetingType.excludeFromSelfService is true, then the meeting type information is not retrievable from server
    // Private meeting type needs to have both bookingUrlCode and not excludeFromSelfService to be accessible
    const meetingTypeHasSharedLink = hasBookingUrlCode && !excludeFromSelfService;

    return meetingTypeHasSharedLink;
}
